import { render, staticRenderFns } from "./LoadMoreButton.vue?vue&type=template&id=2913f7ac&scoped=true&lang=html&"
import script from "./LoadMoreButton.vue?vue&type=script&lang=js&"
export * from "./LoadMoreButton.vue?vue&type=script&lang=js&"
import style0 from "./LoadMoreButton.vue?vue&type=style&index=0&id=2913f7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913f7ac",
  null
  
)

export default component.exports